import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useCreateMatter = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const createMatter = async () => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
    });

    const response = await fetch(`${APIBaseChronos}/api/matters`, fetchConfig);
    if (!response.ok) {
      throw new Error('Error creating matter');
    }
    return response.json();
  };

  return useMutation({
    onError: (error) => {
      console.error('Error creating matter:', error);
      toast.error('Error creating matter');
    },
    mutationFn: createMatter,
    onSuccess: (data) => {
      queryClient.invalidateQueries([QueryEntity.User]);
    },
  });
};
